<template>
  <div class="recent-reviews vertical-review" :class="{ 'mobile-view': !isDesktop }">
    <h3 v-if="isLoadingFinish.recentReviews" class="section-heading">Recently Reviewed</h3>

    <div v-if="isLoadingFinish.recentReviews">
      <div v-if="$SO.size(recentReviews)">
        <CardReviewDetailV2
          v-for="review in recentReviews"
          :key="review._id"
          :show-product="true"
          :review-data="review"
          :is-expert-review="
            (review.user && review.user.is_expert_reviewer) || (review.owner && review.owner.is_expert_reviewer)
          "
          on="recent"
          :left-column="4"
          :class="['recent-reviews', { 'expert-review': review.user.is_expert_reviewer }]"
        />

        <div v-if="finishLoadMoreRecentReview === false">
          <a v-if="isLoadingFinish.loadMore" href="" class="btn btn-loadmore btn-block" @click.prevent="loadMoreReviews"
            >Load more reviews</a
          >
          <a v-else class="btn btn-loadmore btn-block">Loading...</a>
        </div>
      </div>
      <div v-else>
        <p class="text-center">Data Not Found</p>
      </div>
    </div>
    <div v-else>
      <ReviewCardListLoader />
    </div>

    <ModalReport />
  </div>
</template>

<script>
export default {
  name: 'recent-reviews',
  components: {
    CardReviewDetailV2: () => import('./card-review-detail-v2'),
    ModalReport: () => import('@/components/global/modal/modal-report'),
    ReviewCardListLoader: () => import('@/components/global/loader/review-card-list-loader'),
  },
  data() {
    return {
      lastReviewId: null,
      skipData: 0,
      limitData: 10,
      isLoadingFinish: {
        loadMore: true,
        recentReviews: false,
      },
      finishLoadMoreRecentReview: false,
    };
  },
  computed: {
    recentReviews() {
      return this.$store.state.review.recent;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  created() {
    this.getRecentReviews();
  },
  methods: {
    loadMoreReviews() {
      this.isLoadingFinish.loadMore = false;
      this.skipData += this.limitData;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews`, {
          params: {
            filter: {
              _id: { $lt: this.lastReviewId },
              object_type: 'add-review',
            },
            limit: this.limitData,
            sort: '-created_at',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (this.$SO.size(response.data.data)) {
              const reviews = response.data.data || [];

              this.lastReviewId = reviews[reviews.length - 1]._id;
              this.$store.commit('review/MERGE_REVIEW', {
                reviews: reviews,
                on: 'recent',
              });
            } else {
              this.finishLoadMoreRecentReview = true;
            }
          } else {
            this.$store.commit('review/MERGE_REVIEW', {
              reviews: [],
              on: 'recent',
            });

            this.finishLoadMoreRecentReview = true;
          }

          this.isLoadingFinish.loadMore = true;
        })
        .catch((err) => {
          this.isLoadingFinish.loadMore = true;
          this.finishLoadMoreRecentReview = true;
          this.$store.commit('review/MERGE_REVIEW', {
            reviews: [],
            on: 'recent',
          });
        });
    },
    closeDropdown() {
      this.activeDropdown = null;
    },
    toggleDropdown(id) {
      if (this.activeDropdown == id) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = id;
      }
    },
    getRecentReviews() {
      this.isLoadingFinish.recentReviews = false;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews`, {
          params: {
            skip: 0,
            limit: this.limitData,
            sort: '-created_at',
            filter: {
              object_type: 'add-review',
            },
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const reviews = res.data.data || [];
            this.lastReviewId = reviews[reviews.length - 1]._id;
            this.$store.commit('review/SET_REVIEW', {
              reviews: reviews,
              on: 'recent',
            });
          } else {
            this.$store.commit('review/SET_REVIEW', {
              reviews: [],
              on: 'recent',
            });
          }
          this.isLoadingFinish.recentReviews = true;
        })
        .catch((err) => {
          this.$store.commit('review/SET_REVIEW', {
            reviews: [],
            on: 'recent',
          });
          this.isLoadingFinish.recentReviews = true;
        });
    },
    onSetLike(review) {
      const key = this.reviews.findIndex((res) => res._id === review.reviewId);
      if (key > -1) {
        this.$set(this.reviews[key], 'has_liked', review.value);
      }
    },
    onSetBookmark(review) {
      const key = this.reviews.findIndex((res) => res._id === review.reviewId);
      if (key > -1) {
        this.$set(this.reviews[key], 'has_bookmarked', review.value);
      }
    },
  },
};
</script>
